import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
.disclaimer {
    margin-top: calc(24px / 2);
    /*
       note this disclaimer needs to be
       normal paragraph size per:
       US83125
    */
    color: #111111;
    font-size: 16px;
}
.disclaimer a {
  color: #054c70;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
    font-size: 16px;
}
.section-container {
    overflow: hidden;
}
.left {
    width: calc(99.9% * 1/3 - (24px - 24px * 1/3));
    font-size: 12px;
    opacity: 0.6;
}
.left:nth-child(1n) {
    float: left;
    margin-right: 24px;
    clear: none;
}
.left:last-child {
    margin-right: 0;
}
.left:nth-child(3n) {
    margin-right: 0;
    float: right;
}
.left:nth-child(3n + 1) {
    clear: both;
}
.left-bar {
    width: calc(99.9% * 1/2 - (24px - 24px * 1/2));
}
.left-bar:nth-child(1n) {
    float: left;
    margin-right: 24px;
    clear: none;
}
.left-bar:last-child {
    margin-right: 0;
}
.left-bar:nth-child(2n) {
    margin-right: 0;
    float: right;
}
.left-bar:nth-child(2n + 1) {
    clear: both;
}
.right {
    width: calc(99.9% * 1/3 - (24px - 24px * 1/3));
    text-align: right;
    font-size: 12px;
    opacity: 0.6;
}
.right:nth-child(1n) {
    float: left;
    margin-right: 24px;
    clear: none;
}
.right:last-child {
    margin-right: 0;
}
.right:nth-child(3n) {
    margin-right: 0;
    float: right;
}
.right:nth-child(3n + 1) {
    clear: both;
}
.right-bar {
    width: calc(99.9% * 1/2 - (24px - 24px * 1/2));
    text-align: right;
}
.right-bar:nth-child(1n) {
    float: left;
    margin-right: 24px;
    clear: none;
}
.right-bar:last-child {
    margin-right: 0;
}
.right-bar:nth-child(2n) {
    margin-right: 0;
    float: right;
}
.right-bar:nth-child(2n + 1) {
    clear: both;
}
.subsection-no-border {
    padding-top: calc(8px * 2);
    border: none;
}
.labels {
    margin-bottom: 0;
    border-bottom: none;
}
.asset-card-top {
    overflow: hidden;
    margin-bottom: calc(8px * 2);
}
.asset-value-header {
    font-size: 12px;
    opacity: 0.8;
    color: #4c5a6a;
}
.asset-value-price {
    font-size: 16px;
    color: #4c5a6a;
    line-height: 1.38;
}
.bar-indicator {
    height: 34px;
    width: 4px;
    background-color: #054c70;
    margin-right: 8px;
}
.left-bar.bar-indicator {
    margin-right: 8px;
}
`;

export default styles;